export const validateAndClearSingleItemArray = <T extends object>(
  array: T[] | null | undefined,
  isItemEmpty?: (item: T) => boolean
): T[] | null => {
  if (!array || array.length === 0) return null;

  if (array.length === 1) {
    const onlyItem = array[0];

    const isEmpty = isItemEmpty
      ? isItemEmpty(onlyItem)
      : Object.values(onlyItem).every((v) => v === null || v === '' || v === undefined);

    if (isEmpty) return null;
  }

  return array;
};


export const isObjectEffectivelyEmpty = (
  obj: Record<string, any>,
  options: {
    treatFalseAsEmpty?: boolean;
    treatEmptyObjects?: boolean;
    treatEmptyArrays?: boolean;
  } = {}
): boolean => {
  return Object.values(obj).every((value) => {
    if (value === null || value === '') return true;
    if (options.treatFalseAsEmpty && value === false) return true;
    if (options.treatEmptyObjects && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    if (options.treatEmptyArrays && Array.isArray(value) && value.length === 0) return true;
    return false;
  });
};


export const isObjectEmpty = <T extends object>(obj: T): boolean => {
  return Object.values(obj).every((value) => value === null || value === '' || value === undefined);
};

export const isDeeplyEmptyObject = <T extends object>(obj: T): boolean => {
  return Object.values(obj).every((value) => {
    if (value === null || value === '' || value === undefined) {
      return true;
    }

    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (typeof value === 'object') {
      return Object.keys(value).length === 0;
    }

    return false;
  });
};

export const validateAssociationData = (data: any): string[] => {
  const errors: string[] = [];

  if (!data.entityAssociations || data.entityAssociations.length === 0) {
    errors.push('At least one association is required.');
    return errors;
  }

  data.entityAssociations.forEach((assoc: any) => {
    if (!assoc.childEntityId) {
      errors.push('Missing Child Entity ID.');
    }
    if (!assoc.childEntityName) {
      errors.push('Missing Child Entity Name.');
    }
    assoc.associationRecordTypes.forEach((rt: any) => {
      if (!rt.recordTypeId) {
        errors.push('Record Type is required.');
      }
    });
  });

  return errors;
};

